import { render, staticRenderFns } from "./ProfileDialog.vue?vue&type=template&id=3fb99daa&scoped=true"
import script from "./ProfileDialog.vue?vue&type=script&lang=js"
export * from "./ProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./ProfileDialog.vue?vue&type=style&index=0&id=3fb99daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb99daa",
  null
  
)

export default component.exports